import { HostingDisplayName, HostingTypesWithCloudComplianceBoundaries } from '@atlassian/mpac-types';
export const HostingTypes = {
  CLOUD: 'cloud',
  DATA_CENTER: 'dataCenter',
  SERVER: 'server',
  ISOLATED_CLOUD: 'isolatedCloud',
  GOVERNMENT_CLOUD: 'governmentCloud'
};

/**
 * The filter options of ISOLATED_CLOUD and GOVERNMENT_CLOUD are not true hosting-types.
 * They are being aggregated under the hosting-type search filter only for ease of user experience -- to not overwhelm users with additional filters on the UI.
 * The label of this filter is under discussion and this type will be updated once there is a conclusion on it.
 */
export const HostingFilters = statsigClient => {
  const isolatedCloudFilterOption = {
    label: 'Isolated Cloud',
    id: HostingTypes.ISOLATED_CLOUD,
    value: HostingTypes.ISOLATED_CLOUD
  };
  const governmentCloudFilterOption = {
    label: HostingDisplayName[HostingTypesWithCloudComplianceBoundaries.GovernmentCloud],
    id: HostingTypes.GOVERNMENT_CLOUD,
    value: HostingTypes.GOVERNMENT_CLOUD
  };
  return [{
    label: 'Cloud',
    id: HostingTypes.CLOUD,
    value: HostingTypes.CLOUD
  }, {
    label: 'Data Center',
    id: HostingTypes.DATA_CENTER,
    value: HostingTypes.DATA_CENTER
  }, {
    label: 'Server',
    id: HostingTypes.SERVER,
    value: HostingTypes.SERVER
  }, ...(statsigClient.enableIsolatedCloudChanges() ? [isolatedCloudFilterOption] : []), ...(statsigClient.enableFedrampChanges() ? [governmentCloudFilterOption] : [])];
};